import { useUsers } from '../../metodos/userContext';
import React, { useState, useEffect } from 'react';
import { solicitudesApi } from '../../services/api';
import { Cotizacion } from '../../objetos/Solicitud/objeto_solicitud';


export const useHistorialCotizacionesModel = () => {
    const { usuario } = useUsers();
    const [cotizaciones, setCotizaciones] = useState([]);
    const [cargandoCotizaciones, setCargando] = useState(false);
    const [errorCotizaciones, setError] = useState(null);
    const [page, setPage] = useState(1); // CAMBIO: Usar número de página
    const [hasMore, setHasMore] = useState(true);

    const cargarCotizaciones = async (esCargarMas = false) => {
        try {
            setCargando(true);
            setError(null);

            // Si es "Cargar más", usamos la página guardada, si no, empezamos en 1
            const paginaADescargar = esCargarMas ? page : 1;

            const resultado = await solicitudesApi.getTutorCotizaciones(
                usuario.nombrewhatsapp, 
                paginaADescargar, // Enviamos el número de página
                10
            );

            // Convertir datos (Asegúrate que Cotizacion.fromJson soporte el formato)
            const nuevasCotizaciones = resultado.cotizaciones.map(item => Cotizacion.fromJson(item));

            if (esCargarMas) {
                setCotizaciones(prev => [...prev, ...nuevasCotizaciones]);
            } else {
                setCotizaciones(nuevasCotizaciones);
            }

            // Actualizamos estados para la siguiente carga
            setHasMore(resultado.hasMore);
            setPage(resultado.nextPage || paginaADescargar); // Guardamos la siguiente página

        } catch (error) {
            setError('Error al cargar cotizaciones: ' + error.message);
        } finally {
            setCargando(false);
        }
    }

    const cargarMas = () => {
        if (!cargandoCotizaciones && hasMore) {
            cargarCotizaciones(true);
        }
    };

    return {
        cotizaciones,
        cargandoCotizaciones,
        errorCotizaciones,
        cargarCotizaciones,
        cargarMas,
        hasMore,
    };
};
